/**
 * This master application is one that is run on every page.
 *
 * It's for loading essential services required on every page.
 *
 * Keep this module lean! Since it's always loaded and always run, it directly affects the user's
 * experience.
 */

import _ from 'lodash';

import COMMON_IMPORTS from './common.imports';
import {
  configLogProvider,
  configResourceWhitelist,
  configLanguage,
  optimizeApp,
  momentConfig,
  configureKeepaliveInterceptor,
  initialiseFakeLocationService, disableAutoScroll, configureLocalStorage
} from './common.config';
import {disableAngularHashListener, runDebug} from './common.run';
import authServiceModule, {fetchUserFromBackend} from './auth/auth.service';
import keepaliveModule, {
  resetKeepaliveOnSuccessfulRequests,
  resetKeepaliveOnUserAuthentication,
  sendKeepaliveOnHashChanges,
  fetchKeepaliveMetadata, listenToKeepaliveEnabledStatus
} from './common/keepalive/keepalive.service';
import {
  runCheckTemporaries, showIeError, showMaintenanceStripe,
} from './common/master.run';

import flashMessageComponentMod from '../common/flashmessageservice/flashmessage.component';
import flashMessageServiceMod from '../common/flashmessageservice/flashmessageservice.module';
import {appendFlashMessage} from '../common/flashmessageservice/flashmessage.component';
import {initTranslations} from './common/translation.service';
import {reactToHashChanges, reactToPathChanges} from './common/hash.service';
import {appendAnalytics} from "./analytics/analytics.directives";
import analyticsDirMod from './analytics/analytics.directives';
import {whitelistAuthURLs} from './auth_method/auth_method.component';
import {checkSessionAuth, syncAuthToSession} from './auth/auth-session.storage';
import masterConstantsMod from './common/master.constants';
import {checkMaintenanceSessionStatus, storeMaintenanceToSession} from './common/keepalive/maintenance-session.storage';

const mod = angular.module('masterMain', _.union(
  COMMON_IMPORTS,
  configLogProvider.imports,
  configResourceWhitelist.imports,
  configLanguage.imports,
  configureLocalStorage.imports,
  optimizeApp.imports,
  momentConfig.imports,
  runDebug.imports,
  runCheckTemporaries.imports,
  checkSessionAuth.imports,
  syncAuthToSession.imports,
  checkMaintenanceSessionStatus.imports,
  storeMaintenanceToSession.imports,
  fetchUserFromBackend.imports,
  configureKeepaliveInterceptor.imports,
  resetKeepaliveOnSuccessfulRequests.imports,
  resetKeepaliveOnUserAuthentication.imports,
  fetchKeepaliveMetadata.imports,
  listenToKeepaliveEnabledStatus.imports,
  initTranslations.imports,
  initialiseFakeLocationService.imports,
  disableAngularHashListener.imports,
  reactToHashChanges.imports,
  reactToPathChanges.imports,
  whitelistAuthURLs.imports,
  showMaintenanceStripe.imports,
  showIeError.imports,
  [
    authServiceModule,
    keepaliveModule,
    flashMessageComponentMod,
    flashMessageServiceMod,
    analyticsDirMod,
    masterConstantsMod,
  ]
))

.config(configLogProvider)
.config(configResourceWhitelist)
.config(optimizeApp)
.config(momentConfig)
.config(configLanguage)
.config(configureLocalStorage)
.config(configureKeepaliveInterceptor)
.config(initialiseFakeLocationService)
.config(whitelistAuthURLs)
.config(disableAutoScroll)

.run(runDebug)
.run(disableAngularHashListener)
.run(reactToHashChanges)
.run(reactToPathChanges)
.run(initTranslations)
.run(checkSessionAuth)
.run(syncAuthToSession)
.run(checkMaintenanceSessionStatus)
.run(storeMaintenanceToSession)
.run(fetchUserFromBackend)
.run(resetKeepaliveOnSuccessfulRequests)
.run(resetKeepaliveOnUserAuthentication)
.run(sendKeepaliveOnHashChanges)
.run(fetchKeepaliveMetadata)
.run(listenToKeepaliveEnabledStatus)
.run(appendFlashMessage)
.run(runCheckTemporaries)
.run(appendAnalytics)
.run(showMaintenanceStripe)
.run(showIeError)
;

export default mod.name;
